// src/components/layouts/onboarding-layout.tsx
import { Outlet, useLocation } from "react-router-dom";
import { OnboardingHeader } from "@/components/onboarding/OnboardingHeader";
import { OnboardingSidebar } from "@/components/onboarding/OnboardingSidebar";

const DEBUG = import.meta.env.DEV;

// Pages that should have a centered, single-column layout
const centeredPages = [
  "/onboarding/start",
  "/onboarding/analysis",
  "/onboarding/results",
  "/onboarding/tools-choice",
  "/onboarding/keywords",
  "/onboarding/search-terms",
  "/onboarding/ai-run",
  "/onboarding/ai-setup",
  "/onboarding/get-started",
  "/onboarding/quick-wins",
  "/onboarding/benefits",
  "/onboarding/script-challenge",
];

// Path patterns that should be centered (for dynamic routes)
const centeredPathPatterns = [
  /^\/onboarding\/ai-result\//, // Matches /onboarding/ai-result/*
];

export default function OnboardingLayout() {
  const location = useLocation();

  // Check if current path should use sidebar layout
  const useSidebarLayout =
    !centeredPages.includes(location.pathname) &&
    !centeredPathPatterns.some((pattern) => pattern.test(location.pathname));

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <OnboardingHeader />
      <div
        className={`container mx-auto flex flex-1 p-4 ${useSidebarLayout ? "space-x-8" : ""}`}
      >
        {useSidebarLayout ? (
          <>
            <main className="w-3/4">
              <Outlet />
            </main>
            <OnboardingSidebar />
          </>
        ) : (
          <main className="flex-1">
            <Outlet />
          </main>
        )}
      </div>
    </div>
  );
}
